module.exports = require('./lib/immutable');